/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatAggregateDataPoint
 */
export interface StatAggregateDataPoint {
    /**
     * RFC3339 timestamp
     * @type {Date}
     * @memberof StatAggregateDataPoint
     */
    datetime: Date;
    /**
     * 
     * @type {number}
     * @memberof StatAggregateDataPoint
     */
    count: number;
}

/**
 * Check if a given object implements the StatAggregateDataPoint interface.
 */
export function instanceOfStatAggregateDataPoint(value: object): value is StatAggregateDataPoint {
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function StatAggregateDataPointFromJSON(json: any): StatAggregateDataPoint {
    return StatAggregateDataPointFromJSONTyped(json, false);
}

export function StatAggregateDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatAggregateDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'datetime': (new Date(json['datetime'])),
        'count': json['count'],
    };
}

export function StatAggregateDataPointToJSON(json: any): StatAggregateDataPoint {
    return StatAggregateDataPointToJSONTyped(json, false);
}

export function StatAggregateDataPointToJSONTyped(value?: StatAggregateDataPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetime': value['datetime'].toISOString(),
        'count': value['count'],
    };
}

